/* global I18n */

class Pushbar {
  constructor (config = { overlay: true, blur: false }) {
    this.activeId = null
    this.activeElement = null
    this.overlayElement = null
    this.config = config
  }

  emitOpening () {
    const event = new CustomEvent('pushbar_opening', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } })
    this.activeElement.dispatchEvent(event)
  }

  emitClosing () {
    const event = new CustomEvent('pushbar_closing', { bubbles: true, detail: { element: this.activeElement, id: this.activeId } })
    this.activeElement.dispatchEvent(event)
  }

  handleOpenEvent (e) {
    e.preventDefault()
    const pushbarId = e.currentTarget.getAttribute('data-pushbar-target')
    this.open(pushbarId)
  }

  handleCloseEvent (e) {
    e.preventDefault()
    this.close()
  }

  handleKeyEvent (e) {
    if (e.keyCode === 27) this.close()
  }

  bindEvents () {
    const triggers = $('[data-pushbar-target]')
    const closers = $('[data-pushbar-close]')
    const drawerDropdowns = $('[data-role="drawer-dropdown"]')

    triggers.each((_, trigger) => trigger.addEventListener('click', e => this.handleOpenEvent(e), false))
    closers.each((_, closer) => closer.addEventListener('click', e => this.handleCloseEvent(e), false))
    if (this.overlayElement) {
      this.overlayElement.addEventListener('click', e => this.handleCloseEvent(e), false)
    }

    document.addEventListener('keyup', e => this.handleKeyEvent(e))
    drawerDropdowns.on('click', function (e) {
      const $trigger = $(this)
      const href = $(e.target).attr('href')

      if (!href || href === '#') {
        const $chevronIcon = $trigger.find('.chevron-icon')
        const $targetContent = $trigger.next()
        const isOpen = $trigger.hasClass('active')

        if (isOpen) {
          $trigger.removeClass('active')
          $chevronIcon.removeClass('fa-chevron-up').addClass('fa-chevron-down')
          $targetContent.slideUp(350)
        } else {
          $trigger.addClass('active')
          $chevronIcon.removeClass('fa-chevron-down').addClass('fa-chevron-up')
          $targetContent.slideDown(350)
        }
      }
    })
  }

  open (pushbarId) {
    if (this.activeId === String(pushbarId) || !pushbarId) return
    if (this.activeId && this.activeId !== String(pushbarId)) this.close()

    this.render()

    this.activeId = pushbarId
    this.activeElement = document.querySelector(`[data-pushbar-id="${this.activeId}"]`)
    if (!this.activeElement) return
    this.emitOpening()
    this.activeElement.classList.add('opened')
    const pageRootElement = document.querySelector('html')
    pageRootElement.classList.add('pushbar_locked')
    pageRootElement.setAttribute('pushbar', pushbarId)
  }

  close () {
    if (!this.activeId) return
    this.emitClosing()
    this.activeElement.classList.remove('opened')
    const pageRootElement = document.querySelector('html')
    pageRootElement.classList.remove('pushbar_locked')
    pageRootElement.removeAttribute('pushbar')
    this.activeId = null
    this.activeElement = null
  }

  render () {
    if (this.$pushbarContainer) return

    if (this.config.overlay) {
      this.overlayElement = document.createElement('div')
      this.overlayElement.classList.add('pushbar_overlay')
      document.querySelector('body').appendChild(this.overlayElement)
    }

    if (this.config.blur) {
      const mainContent = document.querySelector('.pushbar_main_content')
      if (mainContent) {
        mainContent.classList.add('pushbar_blur')
      }
    }

    const $siteHeader = $('#site-header')
    const $primaryNav = $('.primary-nav__navbar', $siteHeader)

    this.$pushbarContainer = $(this.template).prependTo(document.body)

    const $homeItem = $('li.primary-nav__item.home', $primaryNav)

    if ($homeItem.length) {
      const $homeLink = $homeItem.find('a').first().clone()
      const $homeWrapper = $('<div class="mobile-menu-home"></div>').append($homeLink)
      $('.mobile-menu-close', this.$pushbarContainer).append($homeWrapper)

      $homeItem.addClass('d-none')
    }

    $primaryNav.clone().appendTo('.mobile-menu-wrapper', this.$pushbarContainer).find('> li').each(function () {
      const $li = $(this)
      const $dropdown = $('> .dropdown', $li)
      const $children = $('<div class="children" style="display: none;"></div>')

      if ($dropdown.length) {
        const listHeaderName = $('.dropdown-toggle', $dropdown).text()
        const listHeaderLink = $('.dropdown-toggle', $dropdown).children().attr('href') || '#'

        $(`<div class="primary-nav__link toggle" data-role="drawer-dropdown">
            <a href="${listHeaderLink}">${listHeaderName}</a>
            <div class="switch"><i class="chevron-icon fa-sharp fa-solid fa-chevron-down"></i></div>
          </div>`).appendTo($li)

        $('.dropdown-item', $li).each(function () {
          const listSubHeaderName = $(this).text()
          const listSubHeaderLink = $(this).attr('href')

          if ($(this).hasClass('dropdown-children')) {
            const subHeader = `
              <div class="dropdown-item toggle" data-role="drawer-dropdown">
                <a href="${listSubHeaderLink}">${listSubHeaderName}</a>
                <div class="switch"><i class="chevron-icon fa-sharp fa-solid fa-chevron-down"></i></div>
              </div>`

            $(subHeader).appendTo($children)
          } else if ($(this).data('role') !== 'grandchildren-item') {
            $(this).appendTo($children)
          }
        })

        $children.appendTo($li)
      }

      $dropdown.remove().detach()
    })

    this.bindEvents()

    this.$pushbarContainer.addClass('ready')
  }

  get template () {
    return `
      <div class="mobile-menu-container" data-pushbar-direction="left" data-pushbar-id="mobile-menu" id="pushbar-container">
        <div class="mobile-menu-close border-bottom">
          <button class="btn" data-pushbar-close=""><i class="fa-sharp fa-regular fa-xmark"></i></button>
        </div>
        <div class="mobile-menu-wrapper"></div>
      </div>
    `
  }
}

class OffcanvasNavToggle {
  static async init () {
    const $siteHeader = $('#site-header')
    const $humburgerMenu = $('[data-role="hamburger-menu"]', $siteHeader)
    const $humburgerIcon = $('.hamburger', $humburgerMenu)

    const pushbar = new Pushbar({
      blur: true,
      overlay: true
    })

    $humburgerMenu.on('click', () => {
      pushbar.open('mobile-menu')
      $humburgerIcon.toggleClass('is-active')
    })

    $(window).on('pushbar_closing', () => {
      $humburgerIcon.removeClass('is-active')
    })
  }
}

export default OffcanvasNavToggle
